var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.262 9.25H6A2.75 2.75 0 003.25 12v8A2.75 2.75 0 006 22.75h12A2.75 2.75 0 0020.75 20v-8A2.75 2.75 0 0018 9.25h-.262c-.058-1.804-.34-3.63-1.067-5.085-.42-.84-.998-1.576-1.786-2.102-.793-.528-1.754-.813-2.885-.813-1.131 0-2.092.285-2.885.813-.788.526-1.366 1.263-1.786 2.102-.727 1.454-1.01 3.281-1.067 5.085zm1.5 0h8.475c-.058-1.68-.322-3.244-.908-4.415-.33-.66-.752-1.174-1.276-1.523-.52-.347-1.184-.562-2.053-.562s-1.533.215-2.053.562c-.524.35-.946.862-1.276 1.523-.586 1.171-.85 2.734-.908 4.415zM6 10.75c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8c0-.69-.56-1.25-1.25-1.25H6z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/Privacy.425dfeb00c958195d4cd3379d9020077.svg";
export { ForwardRef as ReactComponent };